var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"no-branch",style:([_vm.isMobile ? { top: '280px' } : { top: '110px' }])},[_vm._v(" کاربر محترم: در حال حاضر سامانه تغذیه برای مدرسه شما فعال نیست. "),_c('img',{staticClass:"food-image",attrs:{"src":require(`../assets/empty-plate.png`)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }